import { Component } from '@grafikr/components';

import attachBw26Specular from 'utils/bw26-specular';

export default Component((node: HTMLElement) => {
  attachBw26Specular(node);
});
